import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { MobileTimePicker } from '@mui/x-date-pickers';

import { LocaleKey, AppLocales } from '../../../utils/language.util';
import FormInputProps from './FormInputProps';

export const FormInputTime = ({ name, control, minTime }: FormInputProps) => {
  const {
    i18n: { language, t },
  } = useTranslation(['common']);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={AppLocales[language as LocaleKey]}
          localeText={{
            cancelButtonLabel: t('timepicker.cancel'),
            okButtonLabel: t('timepicker.accept'),
            timePickerToolbarTitle: t('timepicker.title'),
          }}
        >
          <MobileTimePicker
            value={value}
            onChange={(event) => onChange(event)}
            closeOnSelect
            minutesStep={5}
            minTime={minTime}
          />
        </LocalizationProvider>
      )}
    />
  );
};
